import angular from 'angular';
import { map, sum } from 'lodash';

module.exports = angular.module('common.filters.implied-price-cents', [])
.filter('impliedPriceCents', function() {
  return function(comp) {
    return comp.listing.price_cents + sum(map(comp.comp_adjustments, 'amount_cents'));
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/implied-price-cents.js
 **/